import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import axios from "axios";
import "./MultiStepForm.css";

const MultiStepForm = () => {
  const form = useRef();
  const [step, setStep] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const timeSlots = [
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "01:00 PM",
    "01:30 PM",
    "02:00 PM",
    "02:30 PM",
    "03:00 PM",
    "03:30 PM",
    "04:00 PM",
    "04:30 PM",
    "05:00 PM",
  ];

  const convertTo24 = (timeStr) => {
    let [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");

    if (modifier === "PM" && hours !== "12") hours = parseInt(hours) + 12;
    if (modifier === "AM" && hours === "12") hours = "00";

    return `${hours}:${minutes}`;
  };

  const [values, setValues] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    date: "",
    time: "",
  });

  const update = (field, value) => {
    setValues((prev) => ({ ...prev, [field]: value }));
  };

  const nextDisabled = () => {
    if (step === 1)
      return !(values.name && values.email && values.phone && values.message);
    if (step === 2) return !values.date;
    return false;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const formattedTime = convertTo24(values.time);
    const local = new Date(`${values.date}T${formattedTime}:00`);
    const utc = local.toISOString();

    const utc_date = utc.slice(0, 10);
    const utc_time = utc.slice(11, 19);

    try {
      await axios.post("https://newwayit.com/nwt/website/save_democlass.php", {
        name: values.name,
        email: values.email,
        phone: values.phone,
        message: values.message,
        utc_date,
        utc_time,
      });

      emailjs.send(
        "service_0xcjlk3",
        "template_jrumtwy",
        values,
        "N3TzYuQ2T39T1YTom"
      );

      emailjs.send(
        "service_0xcjlk3",
        "template_ep0mqog",
        { name: values.name, email: values.email, phone: values.phone, date: values.date, time: values.time },
        "N3TzYuQ2T39T1YTom"
      );

      setDone(true);
    } catch (err) {
      console.error(err);
    }

    setSubmitting(false);
  };

  return (
    <div className="msf-container">
      <div className="msf-card">
        <div className="msf-progress">
          <div className={`step ${step >= 1 ? "active" : ""}`}>1</div>
          <div className={`bar ${step >= 2 ? "active" : ""}`}></div>
          <div className={`step ${step >= 2 ? "active" : ""}`}>2</div>
          <div className={`bar ${step >= 3 ? "active" : ""}`}></div>
          <div className={`step ${step === 3 ? "active" : ""}`}>3</div>
        </div>

        {!done ? (
          <form ref={form} onSubmit={sendForm}>
            {step === 1 && (
              <div className="msf-slide fade-in">
                <h5>Personal Information</h5>

                <input
                  type="text"
                  placeholder="Full Name"
                  value={values.name}
                  onChange={(e) => update("name", e.target.value)}
                />

                <input
                  type="email"
                  placeholder="Email"
                  value={values.email}
                  onChange={(e) => update("email", e.target.value)}
                />

                <input
                  type="tel"
                  placeholder="Phone"
                  value={values.phone}
                  onChange={(e) => update("phone", e.target.value)}
                />

                <textarea
                  placeholder="Message"
                  rows={3}
                  value={values.message}
                  onChange={(e) => update("message", e.target.value)}
                ></textarea>

                <button
                  className="next-btn"
                  type="button"
                  disabled={nextDisabled()}
                  onClick={() => setStep(2)}
                >
                  Next → Select Date
                </button>
              </div>
            )}

            {step === 2 && (
              <div className="msf-slide fade-in">
                <h5>Select Date</h5>

                <input
                  type="date"
                  value={values.date}
                  min={new Date().toISOString().split("T")[0]}
                  onChange={(e) => {
                    const selected = e.target.value;
                    const day = new Date(selected).getDay();

                    if (day === 0) {
                      alert("Sundays are not available.");
                      return;
                    }

                    update("date", selected);
                  }}
                  className="form-control"
                />

                <div className="msf-nav">
                  <button
                    type="button"
                    className="back-btn"
                    onClick={() => setStep(1)}
                  >
                    ← Back
                  </button>

                  <button
                    className="next-btn"
                    type="button"
                    disabled={!values.date}
                    onClick={() => setStep(3)}
                  >
                    Next → Select Time
                  </button>
                </div>
              </div>
            )}

            {step === 3 && (
              <div className="msf-slide fade-in">
                <h5>Select Time</h5>

                <div className="time-slot-grid">
                  {timeSlots.map((slot) => (
                    <div
                      key={slot}
                      className={`time-slot ${
                        values.time === slot ? "active" : ""
                      }`}
                      onClick={() => update("time", slot)}
                    >
                      {slot}
                    </div>
                  ))}
                </div>

                <div className="msf-nav">
                  <button
                    type="button"
                    className="back-btn"
                    onClick={() => setStep(2)}
                  >
                    ← Back
                  </button>

                  <button
                    className="submit-btn"
                    type="submit"
                    disabled={!values.time}
                  >
                    {submitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
            )}
          </form>
        ) : (
          <div className="fade-in">
            <h5>🎉 Success!</h5>
            <p>Your form has been submitted.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiStepForm;
